import { render, staticRenderFns } from "./DebtList.vue?vue&type=template&id=8b37536e&"
import script from "./DebtList.vue?vue&type=script&lang=js&"
export * from "./DebtList.vue?vue&type=script&lang=js&"
import style0 from "./DebtList.vue?vue&type=style&index=0&id=8b37536e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports